import {MutationTree} from "vuex";
import {TradeContractFormat, TradeContractFormatState} from "./model";

const mutations: MutationTree<TradeContractFormatState> = {
  setTradeContractFormats(state, formats: TradeContractFormat[]) {
    state.formats = formats;
  },
  addTradeContractFormat(state, format: TradeContractFormat) {
    state.formats.push(format);
  },
  updateTradeContractFormat(state, format: TradeContractFormat) {
    const pos = state.formats.findIndex(c => c.id === format.id);
    if(pos !== -1) {
      state.formats.splice(pos, 1, format);
    }
  },
  deleteTradeContractFormat(state, id: string) {
    const pos = state.formats.findIndex(c => c.id === id);
    if(pos !== -1) {
      state.formats.splice(pos, 1);
    }
  }
}

export default mutations;
